import React, { Fragment, useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import classNames from "classnames";

import styles from "./utils/layout.module.scss";
import Button from "../Elements/Button";

const Navbar = ({ isWellness }) => {
  const data = useStaticQuery(graphql`
    {
      logoLong: file(relativePath: { eq: "logos/medgrocer-long.png" }) {
        childImageSharp {
          fixed(height: 25) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      logoCircle: file(relativePath: { eq: "logos/medgrocer-square.png" }) {
        childImageSharp {
          fixed(height: 25) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);

  const logoLong = data.logoLong.childImageSharp.fixed;
  const logoCircle = data.logoCircle.childImageSharp.fixed;

  const [isMenuActive, setMenuActive] = useState(false);

  const toggleMenu = () => setMenuActive((v) => !v);
  const closeMenu = () => setMenuActive(false);

  const handleSignOut = () => {
    sessionStorage.removeItem("authState");
    window.location.reload();
  };

  const Logo = () => (
    <Link to="/">
      <div className={classNames(styles["navbar__brand--logos"])}>
        <Img fixed={logoLong} className="is-hidden-mobile" />
        <Img fixed={logoCircle} className="is-hidden-tablet" />
      </div>
    </Link>
  );

  return (
    <Fragment>
      <nav className="navbar is-fixed-top is-white">
        <div
          className={classNames("navbar-brand pl-1", styles["navbar__brand"])}
        >
          <Logo />

          {isWellness === false && (
            <div className={styles["navbar__burger-container"]}>
              <a
                role="button"
                aria-label="menu"
                aria-expanded={isMenuActive ? "true" : "false"}
                className={classNames("navbar-burger", {
                  "is-active": isMenuActive,
                })}
                data-target="mainNav"
                tabIndex={0}
                onClick={toggleMenu}
              >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </a>
            </div>
          )}
        </div>

        {isWellness === false && (
          <div
            id="mainNav"
            className={classNames("navbar-menu", styles["navbar__menu"], {
              "is-active": isMenuActive,
            })}
          >
            <div
              className={classNames(
                "navbar-end mr-1",
                styles["navbar__align-center"]
              )}
            >
              {/* <a
                href="https://maxi.care/MGtelecon"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-item has-text-weight-semibold has-text-secondary"
                onClick={closeMenu}
              >
                Teleconsult
              </a> */}
              <Link
                className="navbar-item has-text-weight-semibold has-text-secondary"
                to="/medensure"
                onClick={closeMenu}
              >
                MedEnsure
              </Link>
              <Link
                className="navbar-item has-text-weight-semibold has-text-secondary"
                to="/flexmed"
                onClick={closeMenu}
              >
                FlexMed
              </Link>
              <Button
                className="navbar-item has-text-weight-semibold has-text-secondary"
                onClick={() => {
                  closeMenu();
                  handleSignOut();
                }}
              >
                Sign Out
              </Button>
            </div>
          </div>
        )}
      </nav>

      <div
        role="button"
        tabIndex={0}
        aria-label="Navbar Background"
        className={classNames("is-hidden-desktop", {
          [styles["navbar__background--is-active"]]: isMenuActive,
        })}
        onClick={closeMenu}
      />
    </Fragment>
  );
};

export default Navbar;
